import { mainStore } from 'enasops/stores'
import { $consts } from 'src/plugins'
import { getImgBase } from 'src/utils/axios'

const handleFileUpload = (EditContext: any, FIELD_NAME: any, data: any) => {
  let list = []
  try { list = JSON.parse(data.value) } catch (err) { }
  const files = list.map((item: any) => `${mainStore.baseConfig.FileDomain || getImgBase()}${item.FilePath}`)
  EditContext.setFormBase({
    FILE_URL: files.join(';')
  })
}

export default {
  [$consts['LIFECYCLE/EDIT_PAGE_FORM_LOADED']] (EditContext: any, props: any) {
    const { FILE_PATH } = EditContext.formBase
    handleFileUpload(EditContext, undefined, { value: FILE_PATH })
  },
  fileUpload (EditContext: any, FIELD_NAME: any, data: any) {
    handleFileUpload(EditContext, undefined, data)
  },
}